import React from "react";
import "../../css/Authorization.css";

import rectangleImg from "../../../assets/icons/rectangle-31.png";
import globalImg from "../../../assets/icons/global.jpg";
import patternImg from "../../../assets/icons/pattern.jpg";

function Authorization() {
  return (
    <div className="unique-auth-main-wrapper">

      {/* ================= TOP SECTION ================= */}

      <div className="unique-auth-top-section">

        <h1 className="unique-auth-main-heading">
          Secure, Seamless Login Experience
        </h1>

        <p className="unique-auth-main-subtitle">
          Easily access your FrothTestops account with trusted multi-factor authentication.
        </p>

        <div className="unique-auth-card-container">

          <div className="unique-auth-card">

            <div className="unique-auth-card-icon">
              <img src={rectangleImg} alt="Microsoft Authenticator" />
            </div>

            <div>
              <div className="unique-auth-card-title">
                Microsoft Authenticator
              </div>

              <div className="unique-auth-card-description">
                Secure your test data.
              </div>
            </div>

          </div>

        </div>

        {/* Decorative Patterns */}

        <div
          className="unique-auth-pattern-circle unique-auth-pattern-top-left"
          style={{ backgroundImage: `url(${patternImg})` }}
        />

        <div
          className="unique-auth-pattern-circle unique-auth-pattern-top-right"
          style={{ backgroundImage: `url(${patternImg})` }}
        />

        <div
          className="unique-auth-pattern-circle unique-auth-pattern-bottom-right"
          style={{ backgroundImage: `url(${patternImg})` }}
        />

      </div>

      {/* ================= BOTTOM SECTION ================= */}

      <div className="unique-auth-bottom-grid">

        {/* LEFT IMAGE */}

        <div className="unique-auth-left-image-wrapper">
          <img src={globalImg} alt="Security" />
        </div>

        {/* RIGHT CONTENT */}

        <div className="unique-auth-right-content-card">

          <h2>
            How FrothTestops Ensures Seamless Test Execution
          </h2>

          <p>
            <b>Smart Configuration</b> – The tool FrothTestops adjusts itself automatically to your testing conditions by setting up test parameters that can be used not only by devices but also teams, thus the time needed for the preparation is cut down and the accuracy of the tests is ensured.
          </p>

          <p>
            <b>Dynamic Test Mapping</b> – Team members get to use the platform-generated mappings that are not only shared but also on the same page regarding test coverage and expected behavior.
          </p>

          <p>
            <b>Secure Execution & Sync</b> – The performance of the tests is done in a secure manner and the updates of these tests are also done in real-time for the mobile and web branch. Any time from the start to the end of a test, logs, results, and defect records can be seen, and traced instantly.
          </p>

        </div>

      </div>

    </div>
  );
}

export default Authorization;